var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"focus",class:{ 'focus-checkbox': _vm.type === 'checkbox', disabled: _vm.disabled },attrs:{"tabindex":"0"},on:{"focus":_vm.setListener,"blur":_vm.clearListener}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }